import React from "react";
import { useTranslation } from "react-i18next";
import { CustomButton, SliderCard } from "../../components";
import { CloseGray } from "../../assets/svgs";
import "./styles.scss";

const LoanDisbursementModal = ({
  visible,
  buttonText,
  onClickButton,
  value,
  onChange,
  onClickClose,
}) => {
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <div className="loan-disbursement-modal-container">
      <div className="loan-disbursement-modal-content">
        <img
          src={CloseGray}
          alt="close-gray-icon"
          className="loan-disbursement-modal-close-icon"
          onClick={onClickClose}
        />
        <p className="loan-disbursement-modal-heading">
          {t("finance-detail.loan_disbursement_heading")}
        </p>
        <p className="loan-disbursement-modal-description">
          {t("finance-detail.loan_disbursement_description")}
        </p>
        <SliderCard
          value={value}
          valueSuffix={"slider_card_amount_value_suffix"}
          onChange={onChange}
          minValue={20000}
          maxValue={100000}
          labelSuffix={"slider_card_amount_label_suffix"}
        />
        <div className="loan-disbursement-modal-details-card">
          <div className="loan-disbursement-modal-details-card-item">
            <p className="loan-disbursement-modal-details-card-label">
              {t("finance-detail.installment_label")}
            </p>
            <p className="loan-disbursement-modal-details-card-value">
              2,000 SAR
            </p>
          </div>
          <div className="loan-disbursement-modal-details-card-item">
            <p className="loan-disbursement-modal-details-card-label">
              {t("finance-detail.inrest_rate_label")}
            </p>
            <p className="loan-disbursement-modal-details-card-value">2%</p>
          </div>
          <div className="loan-disbursement-modal-details-card-item">
            <p className="loan-disbursement-modal-details-card-label">
              {t("finance-detail.adminstative_fees_label")}
            </p>
            <p className="loan-disbursement-modal-details-card-value">
              2000.34 SAR
            </p>
          </div>
        </div>
        <CustomButton text={buttonText} onClick={onClickButton} />
      </div>
    </div>
  );
};

export default LoanDisbursementModal;
